import winterParkMain from "../../assets/projects/winter-park/main.jpg";
import winterPark1 from "../../assets/projects/winter-park/1.jpg";
import winterPark2 from "../../assets/projects/winter-park/2.jpg";
import winterPark3 from "../../assets/projects/winter-park/3.jpg";
import winterPark4 from "../../assets/projects/winter-park/4.jpg";
import winterParkVideo from "../../assets/projects/winter-park/project1.mp4";
import auroraMain from "../../assets/projects/aurora/main.jpg";
import aurora1 from "../../assets/projects/aurora/1.jpg";
import aurora2 from "../../assets/projects/aurora/2.jpg";
import aurora3 from "../../assets/projects/aurora/3.jpg";
import aurora4 from "../../assets/projects/aurora/4.jpg";
import denverJuneMain from "../../assets/projects/denver-june-2021/main.jpg";
import denverJune1 from "../../assets/projects/denver-june-2021/1.jpg";
import denverJune2 from "../../assets/projects/denver-june-2021/2.jpg";
import denverJune3 from "../../assets/projects/denver-june-2021/3.jpg";
import denverJune4 from "../../assets/projects/denver-june-2021/4.jpg";
import denverJuneVideo from "../../assets/projects/denver-june-2021/project3.mp4";
import geneseeAugustMain from "../../assets/projects/genesee-august-2021/main.jpg";
import geneseeAugust1 from "../../assets/projects/genesee-august-2021/1.jpg";
import geneseeAugust2 from "../../assets/projects/genesee-august-2021/2.jpg";
import geneseeAugust3 from "../../assets/projects/genesee-august-2021/3.jpg";
import geneseeAugust4 from "../../assets/projects/genesee-august-2021/4.jpg";
import denverJanuaryMain from "../../assets/projects/denver-january-2023/main.jpg";
import denverJanuary1 from "../../assets/projects/denver-january-2023/1.jpg";
import denverJanuary2 from "../../assets/projects/denver-january-2023/2.jpg";
import denverJanuary3 from "../../assets/projects/denver-january-2023/3.jpg";
import denverJanuary4 from "../../assets/projects/denver-january-2023/4.jpg";
import denverJanuary5 from "../../assets/projects/denver-january-2023/5.jpg";
import denverJanuary6 from "../../assets/projects/denver-january-2023/6.jpg";
import denverJanuary7 from "../../assets/projects/denver-january-2023/7.jpg";
import denverJanuary8 from "../../assets/projects/denver-january-2023/8.jpg";
import denverNovemberMain from "../../assets/projects/denver-november-2021/main.jpg";
import denverNovember1 from "../../assets/projects/denver-november-2021/1.jpg";
import denverNovember2 from "../../assets/projects/denver-november-2021/2.jpg";
import denverNovember3 from "../../assets/projects/denver-november-2021/3.jpg";
import denverNovember4 from "../../assets/projects/denver-november-2021/4.jpg";
import denverNovember5 from "../../assets/projects/denver-november-2021/5.jpg";
import denverNovember6 from "../../assets/projects/denver-november-2021/6.jpg";
import geneseeDecemberMain from "../../assets/projects/genesee-december-2022/main.jpg";
import geneseeDecember1 from "../../assets/projects/genesee-december-2022/1.jpg";
import geneseeDecember2 from "../../assets/projects/genesee-december-2022/2.jpg";
import geneseeDecember3 from "../../assets/projects/genesee-december-2022/3.jpg";
import geneseeDecember4 from "../../assets/projects/genesee-december-2022/4.jpg";
import geneseeDecember5 from "../../assets/projects/genesee-december-2022/5.jpg";
import geneseeDecember6 from "../../assets/projects/genesee-december-2022/6.jpg";
import geneseeJuneMain from "../../assets/projects/genesee-june-2023/main.jpg";
import geneseeJune1 from "../../assets/projects/genesee-june-2023/1.jpg";
import geneseeJune2 from "../../assets/projects/genesee-june-2023/2.jpg";
import geneseeJune3 from "../../assets/projects/genesee-june-2023/3.jpg";
import geneseeJune4 from "../../assets/projects/genesee-june-2023/4.jpg";
import geneseeJune5 from "../../assets/projects/genesee-june-2023/5.jpg";
import geneseeJune6 from "../../assets/projects/genesee-june-2023/6.jpg";
import geneseeJune7 from "../../assets/projects/genesee-june-2023/7.jpg";
import geneseeJune8 from "../../assets/projects/genesee-june-2023/8.jpg";
import evergreenMain from "../../assets/projects/evergreen-september-2024/main.jpg";
import evergreen1 from "../../assets/projects/evergreen-september-2024/1.jpg";
import evergreen2 from "../../assets/projects/evergreen-september-2024/2.jpg";
import evergreen3 from "../../assets/projects/evergreen-september-2024/3.jpg";
import evergreen4 from "../../assets/projects/evergreen-september-2024/4.jpg";
import evergreen5 from "../../assets/projects/evergreen-september-2024/5.jpg";
import evergreen6 from "../../assets/projects/evergreen-september-2024/6.jpg";
import evergreen7 from "../../assets/projects/evergreen-september-2024/7.jpg";
import evergreen8 from "../../assets/projects/evergreen-september-2024/8.jpg";
import evergreen9 from "../../assets/projects/evergreen-september-2024/9.jpg";
import evergreen10 from "../../assets/projects/evergreen-september-2024/10.jpg";
import evergreen11 from "../../assets/projects/evergreen-september-2024/11.jpg";
import evergreen12 from "../../assets/projects/evergreen-september-2024/12.jpg";
import evergreen13 from "../../assets/projects/evergreen-september-2024/13.jpg";
import evergreen14 from "../../assets/projects/evergreen-september-2024/14.jpg";
import evergreen15 from "../../assets/projects/evergreen-september-2024/15.jpg";

const createProject = ({ id, title, date, mainImage, images, video }) => ({
  id,
  title,
  text: date,
  alt: `${title} kitchen project`,
  img: mainImage,
  video,
  collection: images.map((img, index) => ({
    id: index + 1,
    img,
    alt: `${title} kitchen project, view ${index + 1}`,
    title,
    text: date,
  })),
});

export const PORTFOLIO_LIST = [
  createProject({
    id: 1,
    title: "Winter Park",
    date: "Feb 2023",
    mainImage: winterParkMain,
    images: [winterPark1, winterPark2, winterPark3, winterPark4],
    video: winterParkVideo,
  }),
  createProject({
    id: 2,
    title: "Aurora",
    date: "Oct 2020",
    mainImage: auroraMain,
    images: [aurora1, aurora2, aurora3, aurora4],
  }),
  createProject({
    id: 3,
    title: "Denver",
    date: "Jun 2021",
    mainImage: denverJuneMain,
    images: [denverJune1, denverJune2, denverJune3, denverJune4],
    video: denverJuneVideo,
  }),
  createProject({
    id: 4,
    title: "Genesee",
    date: "Aug 2021",
    mainImage: geneseeAugustMain,
    images: [geneseeAugust1, geneseeAugust2, geneseeAugust3, geneseeAugust4],
  }),
  createProject({
    id: 5,
    title: "Denver",
    date: "Jan 2023",
    mainImage: denverJanuaryMain,
    images: [
      denverJanuary1,
      denverJanuary2,
      denverJanuary3,
      denverJanuary4,
      denverJanuary5,
      denverJanuary6,
      denverJanuary7,
      denverJanuary8,
    ],
  }),
  createProject({
    id: 6,
    title: "Denver",
    date: "Nov 2021",
    mainImage: denverNovemberMain,
    images: [
      denverNovember1,
      denverNovember2,
      denverNovember3,
      denverNovember4,
      denverNovember5,
      denverNovember6,
    ],
  }),
  createProject({
    id: 7,
    title: "Genesee",
    date: "Dec 2022",
    mainImage: geneseeDecemberMain,
    images: [
      geneseeDecember1,
      geneseeDecember2,
      geneseeDecember3,
      geneseeDecember4,
      geneseeDecember5,
      geneseeDecember6,
    ],
  }),
  createProject({
    id: 8,
    title: "Genesee",
    date: "Jun 2023",
    mainImage: geneseeJuneMain,
    images: [
      geneseeJune1,
      geneseeJune2,
      geneseeJune3,
      geneseeJune4,
      geneseeJune5,
      geneseeJune6,
      geneseeJune7,
      geneseeJune8,
    ],
  }),
  createProject({
    id: 9,
    title: "Evergreen",
    date: "Sep 2024",
    mainImage: evergreenMain,
    images: [
      evergreen1,
      evergreen2,
      evergreen3,
      evergreen4,
      evergreen5,
      evergreen6,
      evergreen7,
      evergreen8,
      evergreen9,
      evergreen10,
      evergreen11,
      evergreen12,
      evergreen13,
      evergreen14,
      evergreen15,
    ],
  }),
];

export const SORTED_PORTFOLIO_LIST = [...PORTFOLIO_LIST].sort(
  (firstProject, secondProject) =>
    Date.parse(secondProject.text) - Date.parse(firstProject.text)
);
